export default __webpack_public_path__ + "static/media/maps.cf61318c.png";